import { gql } from 'graphql-request';
import withFragments from 'utils/graphql';

import CTABlock from 'fragments/CTABlock';
import FAQBlock from 'fragments/Faq';
import Contact from 'fragments/Contact';
import { LinkBlock, CustomEmbedBlock } from 'fragments/GenericBlocks';
import Logo from 'fragments/Logo';

export default withFragments(
  gql`
    query($id: Int, $contentType: String!, $token: String!, $hostname: String) {
      page(id: $id, contentType: $contentType, token: $token) {
        id
        url
        title
        slug
        seoTitle
        seoDescription
        ... on ServicePage {
          metaImage {
            url
          }
          metaTitle
          metaDescription
          logo {
            ...Logo
          }
          optionalBody {
            id
            blockType
            ...CTABlock
            ...Faq
            ...Contact
            ...CustomEmbedBlock
          }
          bodyRt
          introduction
          breadcrumbs {
            url
            title
          }
          category {
            name
            id
            services(hostname: $hostname) {
              id
              title
              slug
              url
            }
          }
          otherServices {
            ... on OtherServicesBlock {
              title
              categories {
                ... on CategoryChooserBlock {
                  name
                  id
                  services(hostname: $hostname) {
                    id
                    title
                    slug
                    url
                  }
                }
              }
            }
          }
          ctaTitle
          ctaLink {
            ...LinkBlock
          }
          checklistTitle
          checklist {
            ... on ChecklistItemBlock {
              content
            }
          }
          image {
            ... on ImageObjectType {
              title
              lg: rendition(fill: "900x280-c100") {
                url
              }
              sm: rendition(fill: "640x150-c100") {
                url
              }
            }
          }
        }
      }
    }
  `,
  { CTABlock, FAQBlock, LinkBlock, CustomEmbedBlock, Contact, Logo },
);
